import api from './api';

export interface ContractorPlan {
  _id: string;
  name: string;
  description: string;
  monthlyFee: number;
  annualFee: number;
  billingPeriod: 'monthly' | 'annual' | 'both' | 'hybrid';
  features: string[];
  isActive: boolean;
  sortOrder: number;
  trialDays?: number;
  stripeProductId: string;
  stripeMonthlyPriceId?: string;
  stripeAnnualPriceId?: string;
  metadata?: Record<string, string>;
}

export interface ContractorSubscription {
  hasSubscription: boolean;
  subscriptionStatus?: 'active' | 'expired' | 'cancelled' | 'free';
  subscriptionStartDate?: string;
  subscriptionEndDate?: string;
  stripeCustomerId?: string;
  stripeSubscriptionId?: string;
  totalJobsAssigned: number;
  canPerformAction: {
    allowed: boolean;
    remaining: number;
  };
}

export interface CreateSubscriptionRequest {
  email: string;
  planId: string;
  paymentMethodId: string;
  billingCycle?: 'monthly' | 'annual';
}

export interface CreateSubscriptionResponse {
  success: boolean;
  subscription: {
    id: string;
    status: string;
    currentPeriodEnd: number;
    clientSecret?: string;
  };
}

export const contractorSubscriptionService = {
  // Get contractor subscription status
  async getSubscription(email: string): Promise<ContractorSubscription> {
    const response = await api.get(`/contractors/subscription/${email}`);
    return response.data;
  },

  // Create contractor subscription
  async createSubscription(data: CreateSubscriptionRequest): Promise<CreateSubscriptionResponse> {
    const response = await api.post('/contractors/subscription', data);
    return response.data;
  },

  // Get available contractor plans
  async getPlans(): Promise<ContractorPlan[]> {
    const response = await api.get('/contractors/plans');
    return response.data;
  },

  // Get all jobs for a contractor (dashboard) - uses contractor token from localStorage
  async getContractorJobs(): Promise<any> {
    const response = await api.get('/jobs/dashboard');
    return response.data;
  },

  // Update payment method
  async updatePaymentMethod(email: string, paymentMethodId: string): Promise<any> {
    const response = await api.post(`/contractors/subscription/${email}/payment-method`, {
      paymentMethodId
    });
    return response.data;
  },

  // Cancel subscription
  async cancelSubscription(email: string): Promise<any> {
    const response = await api.post(`/contractors/subscription/${email}/cancel`);
    return response.data;
  }
};
